import {request} from "../../utils/apiUtils";
import {URL_API} from "../../url.config";

let CampaignController = {
    getList: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/campaign/list`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    create: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/campaign/create`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    edit: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/campaign/edit`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    detail: (campaignId, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/campaign/detail/${campaignId}`,
            method: 'GET',
        }, callback)
    },
    delete: (campaignId, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/campaign/delete/${campaignId}`,
            method: 'GET',
        }, callback)
    }
}

export default CampaignController
